/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./AroundRecommend.vue?vue&type=template&id=28c31f14&scoped=true&"
import script from "./AroundRecommend.vue?vue&type=script&lang=ts&"
export * from "./AroundRecommend.vue?vue&type=script&lang=ts&"
import style0 from "./AroundRecommend.vue?vue&type=style&index=0&id=28c31f14&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c31f14",
  null
  
)

export default component.exports